<!-- search-types Templates -->
<ng-template #flightairtemp let-r="result" let-t="term">
  <div class="light-flex">
    @if (!r.group) {
      <i class="ico-flight item-icon" aria-hidden="true"></i>
    }
    @if (r.group) {
      <span class="multiairportgrouping">
        <i class="ico-flight" aria-hidden="true"></i>
      </span>
    }
    <span class="item-code">{{ r.code }}</span>
    <span class="item-dest">{{ r.destination | flightFormat }} ({{ r.gateway }})</span>
  </div>
</ng-template>

<div class="multi-city-container">
  <div class="flight-search-wrapper">
    <fieldset>
      <legend class="visuallyhidden">Flight {{ flightIndex + 1 }}</legend>
      <div class="flight-search-container">
        <div class="inputs-container">
          <div class="five-eighths-container flex-row-container--start">
            <div class="five-eighth">
              <div class="flex-row-container">
                <div class="flex-column-container combo-box-left">
                  <label
                    id="outboundFlight"
                    class="header-label"
                    i18n="@@flightSearchOutboundDep"
                    for="flight-input-outbound-flight-depart-{{ flightIndex }}"
                    >From</label
                  >
                  <i class="ico-icon-takeoff combo-box-icon" aria-hidden="true"></i>
                  <input
                    autocomplete="off"
                    name="flight{{ flightIndex }}"
                    i18n-placeholder
                    placeholder="Enter an airport"
                    type="text"
                    id="flight-input-outbound-flight-depart-{{ flightIndex }}"
                    appInput
                    [(ngModel)]="flight.orig"
                    [ngbTypeahead]="flightLocations"
                    [resultTemplate]="flightairtemp"
                    [inputFormatter]="formatter_rail_air"
                    (click)="updateTemp(flightIndex)"
                    (focus)="focus$.next($event.target.value)"
                    (ngModelChange)="updateTemp(flightIndex)"
                  />
                </div>
                <div class="flex-column-container combo-box-right">
                  <label
                    id="outboundFlight"
                    class="header-label"
                    i18n="@@flightSearchOutboundArr"
                    for="flight-input-outbound-flight-arrive-{{ flightIndex }}"
                    >To</label
                  >
                  <i class="ico-icon-landing combo-box-icon" aria-hidden="true"></i>
                  <input
                    #ofa
                    autocomplete="off"
                    name="flight{{ flightIndex }}"
                    i18n-placeholder
                    placeholder="Enter an airport"
                    type="text"
                    id="flight-input-outbound-flight-arrive-{{ flightIndex }}"
                    appInput
                    [(ngModel)]="flight.dest"
                    [ngbTypeahead]="flightLocations2"
                    [resultTemplate]="flightairtemp"
                    [inputFormatter]="formatter_rail_air"
                    (click)="updateTemp(flightIndex)"
                    (ngModelChange)="updateTemp(flightIndex)"
                    (focus)="focus2$.next($event.target.value)"
                  />
                </div>
              </div>
            </div>

            <div class="three-eighth">
              <div class="flex-row-container">
                <ngbd-datepicker-i18n>
                  <div class="flex-column-container two-third">
                    <label
                      class="header-label date-label"
                      i18n="@@ferrySearchOutboundDate"
                      for="flight_date_{{ flightIndex }}"
                      >Outbound date (DD/MM/YYYY)</label
                    >
                    <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                    <app-datepicker
                      [minDate]="minDate"
                      [startDate]="date"
                      [model]="date"
                      [class]="'combo-box'"
                      [componentId]="'flight_date_' + flightIndex"
                      (newDate)="updateTemp(flightIndex, $event)"
                    >
                    </app-datepicker>
                  </div>
                  <div class="flex-column-container one-third">
                    <label
                      i18n="@@AriaRailOutboundTime"
                      class="header-label"
                      for="flight_time_{{ flightIndex }}"
                      >Outbound time</label
                    >
                    <i class="ico-clock select-box-icon" aria-hidden="true"></i>
                    <select
                      id="flight_time_{{ flightIndex }}"
                      appSelect
                      [(ngModel)]="time"
                      (ngModelChange)="updateTemp(flightIndex)"
                      aria-labelledby="aria-flight-outbound-time_1"
                      tabindex="0"
                      [ngClass]="{ time_disabled: flight.outTimeCriteria === TimeWindow.Anytime }"
                      [disabled]="flight.outTimeCriteria === TimeWindow.Anytime"
                    >
                      @for (time of searchParams.timeArray ?? []; track time) {
                        <option [ngValue]="time.value">
                          {{ time.display }}
                        </option>
                      }
                    </select>
                  </div>
                  @if (flight.outTimeCriteria === TimeWindow.Depart) {
                    <div class="time-flexibility-container">
                      <div class="flex-column-container">
                        <label
                          i18n="@@flightSearchFlex"
                          class="header-label"
                          for="flight_flexibility_{{ flightIndex }}"
                          >Flexibility</label
                        >
                        <span
                          [id]="'aria-out-time-flexibility-' + flightIndex"
                          hidden
                          i18n="@@AriaOutboundIncreaseDecrease"
                          >Ability to increase / decrease time window</span
                        >
                        <app-plus-minus-icon></app-plus-minus-icon>
                        <select
                          [ngClass]="{
                            time_disabled: flight.outTimeCriteria === TimeWindow.Anytime
                          }"
                          [disabled]="flight.outTimeCriteria === TimeWindow.Anytime"
                          name="out-time-flexibility"
                          i18n-placeholder
                          [attr.aria-describedby]="'aria-out-time-flexibility-' + flightIndex"
                          appSelect
                          [(ngModel)]="flight.outTimeFlexibility"
                          id="flight_flexibility_{{ flightIndex }}"
                        >
                          @for (hour of flexibilityHours; track hour) {
                            <option [value]="hour">{{ hour }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                </ngbd-datepicker-i18n>
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex-row-container flex-row-container--right flex-row-container--tb-margin flex-row-container--reset"
        >
          <mat-radio-group
            [(ngModel)]="flight.outTimeCriteria"
            aria-label="outbound flight time preferences"
            i18n-aria-label="@@AriaOutboundFlightTimePreferences"
            class="triple-radio-buttons"
          >
            @for (flightcrit of criteria; track flightcrit) {
              <mat-radio-button
                class="light-primary"
                color="primary"
                id="flight-radio-{{ flightIndex }}-crit-{{
                  flightcrit ? (flightcrit | removeSpaces) : ''
                }}"
                [value]="flightcrit"
              >
                {{ flightcrit | translate }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    </fieldset>
  </div>

  <div class="remove-icon-wrapper">
    @if (flightIndex >= 2) {
      <fa-icon
        (click)="removeFlight(flightIndex)"
        [icon]="faTrash"
        class="fa-fw remove-flight-button"
      ></fa-icon>
    }
  </div>
</div>
